// extracted by mini-css-extract-plugin
export default {"card":"O4-z"};